<h2>{{title}}</h2>

<p>{{message}}</p>

<div class="row justify-content-around mx-0" *ngIf="question">
  <button class="btn btn-outline-danger col-auto" (click)="cancel()">{{ 'Sellers.Products.No' | translate }}</button>
  <button class="btn btn-outline-success col-auto" (click)="sure()">{{ 'Sellers.Products.Yes' | translate }}</button>
</div>
